import { atom } from 'jotai';

export type TImpersonationState = Readonly<{
  azureAdId: Maybe<string>;
}>;

export const INITIAL_IMPERSONATION_STATE = {
  azureAdId: null,
};

const impersonationAtom = atom<TImpersonationState>(INITIAL_IMPERSONATION_STATE);

export { impersonationAtom };
